import React from 'react';
import styled from 'styled-components';
import SocialMenu from './SocialMenu';

const SizeCalculatorStyled = styled.div`
  max-width: 1000px;
  width: 100%;
  margin: 2rem 0;
  padding: 2rem;
  background: var(--backgroundCard);
  border-radius: var(--borderRadius);
  box-shadow: var(--boxShadow);
  @media (max-width: 1023px) {
    width: auto;
    margin: 1rem;
    padding: 1rem;
  }
  .size-inputs {
    width: 100%;
    display: flex;
    gap: 1rem;
    margin: 2rem auto;
    justify-content: space-between;
    align-items: center;
    .side-by-side {
      display: flex;
      gap: 0.5rem;
    }
    input {
      border: 1px solid var(--textColor);
      border-radius: 2px;
      padding-inline: 1rem;
      margin-bottom: 1rem;
      color: var(--textColor);
    }
    label {
      font-size: 1.15rem;
      margin-bottom: 0.5rem;
    }
    button {
      border-radius: 5px;
      font-size: 1.2rem;
      height: 40px;
    }
  }
  .validate {
    font-style: italic;
    font-size: 1.1rem;
    color: var(--bont);
  }
  .size-calculator {
    display: grid;
    grid-template-columns: 1fr;
  }
  @media (max-width: 1023px) {
    padding: 2rem;
    .size-inputs {
      flex-direction: column;
    }
    .size-calculator {
      grid-template-columns: 1fr;
      grid-gap: 1rem;
      align-items: center;
    }
    input {
      width: 100%;
      min-width: auto;
    }
  }
  @media (max-width: 390px) {
    grid-column: 1 / 1;
    .footer-subscribe {
      grid-template-columns: 1fr;
    }
  }
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  li {
    display: inline-block;
    margin-right: 2rem;
  }
  a {
    color: var(--white);
    text-decoration: none;
    &:hover {
      color: var(--watermelon);
    }
  }
  a svg {
    vertical-align: middle;
  }
  p {
    margin: 0 0 1rem;
  }
`;

function sizeCalculation(length) {
  const size = [];
  if (length >= 216 && length <= 220) {
    size.bont = '4';
    size.euro = '36';
    return size;
  }
  if (length >= 221 && length <= 225) {
    size.bont = '4.5';
    size.euro = '37';
    return size;
  }
  if (length >= 226 && length <= 230) {
    size.bont = '5';
    size.euro = '38';
    return size;
  }
  if (length >= 231 && length <= 235) {
    size.bont = '6';
    size.euro = '39';
    return size;
  }
  if (length >= 236 && length <= 240) {
    size.bont = '6.5';
    size.euro = '40';
    return size;
  }
  if (length >= 241 && length <= 245) {
    size.bont = '7';
    size.euro = '40.5';
    return size;
  }
  if (length >= 246 && length <= 250) {
    size.bont = '7.5';
    size.euro = '41';
    return size;
  }
  if (length >= 251 && length <= 255) {
    size.bont = '8';
    size.euro = '42';
    return size;
  }
  if (length >= 256 && length <= 260) {
    size.bont = '8.5';
    size.euro = '42.5';
    return size;
  }
  if (length >= 261 && length <= 265) {
    size.bont = '9';
    size.euro = '43';
    return size;
  }
  if (length >= 266 && length <= 270) {
    size.bont = '9.5';
    size.euro = '44';
    return size;
  }
  if (length >= 271 && length <= 275) {
    size.bont = '10';
    size.euro = '44.5';
    return size;
  }
  if (length >= 276 && length <= 280) {
    size.bont = '10.5';
    size.euro = '45';
    return size;
  }
  if (length >= 281 && length <= 285) {
    size.bont = '11';
    size.euro = '46';
    return size;
  }
  if (length >= 286 && length <= 290) {
    size.bont = '11.5';
    size.euro = '46.5';
    return size;
  }
  if (length >= 291 && length <= 295) {
    size.bont = '12';
    size.euro = '47';
    return size;
  }
  if (length >= 296 && length <= 300) {
    size.bont = '12.5';
    size.euro = '48';
    return size;
  }
  if (length >= 301 && length <= 305) {
    size.bont = '13';
    size.euro = '49';
    return size;
  }
  if (length >= 306 && length <= 310) {
    size.bont = '14';
    size.euro = '50';
    return size;
  }
  if (length >= 311 && length <= 315) {
    size.bont = '15';
    size.euro = '51';
    return size;
  }
  if (length >= 316 && length <= 320) {
    size.bont = '16';
    size.euro = '52';
    return size;
  }
  if (length >= 321 && length <= 325) {
    size.bont = '17';
    size.euro = '53';
    return size;
  }
}

function calculateSize(e) {
  const footLength = document.querySelector('.foot-length');
  const validate = document.querySelector('.validate');
  const brSize = document.querySelector('.br-size');
  const euSize = document.querySelector('.eu-size');
  validate.textContent = '';
  brSize.value = '';
  euSize.value = '';
  if (footLength.value <= 215 || footLength.value >= 326) {
    validate.textContent =
      'Outside our standard size range. Please contact us for custom shoes.';
    return;
  }
  const size = sizeCalculation(footLength.value);
  console.log(size);
  brSize.value = size.bont;
  euSize.value = size.euro;
}

export default function SizeCalculator() {
  return (
    <SizeCalculatorStyled>
      <h4>Size Calculator</h4>
      <div className="size-calculator">
        <div className="size-calculator-intro">
          <p>
            Enter your foot length in the field below to get a size estimate.
          </p>
        </div>
        <div className="size-inputs">
          <div>
            <label htmlFor="footLength">Foot length (MM)</label>
            <div className="side-by-side">
              <input
                id="footLength"
                className="foot-length"
                name="footLength"
              />
              <button onClick={calculateSize}>Submit</button>
            </div>
          </div>
          <div>
            <label htmlFor="brSize">Bont Rowing US size</label>
            <input id="brSize" className="br-size" name="brSize" disabled />
          </div>
          <div>
            <label htmlFor="euSize">Bont Rowing EU size</label>
            <input id="euSize" className="eu-size" name="euSize" disabled />
          </div>
        </div>
        <span className="validate" />
      </div>
    </SizeCalculatorStyled>
  );
}
